var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    [_vm.$c('badge')]: true,
    [_vm.$c('badge-standalone')]: !_vm.$scopedSlots.default
  }},[_vm._t("default"),_c('transition',{attrs:{"name":_vm.$c('badge')}},[(!_vm.hidden)?_c('span',{class:{
        [_vm.$c('badge-main')]: true,
        [_vm.$c(
          `badge-${_vm.content && _vm.$scopedSlots.default ? 'label' : 'dot'}`
        )]: true,
        [_vm.$c(`badge-${_vm.type}`)]: true
      }},[_vm._v(_vm._s(_vm.$scopedSlots.default ? _vm.content : ''))]):_vm._e()]),(!_vm.$scopedSlots.default && _vm.value)?_c('span',{class:_vm.$c('badge-standalone-label')},[_vm._v(" "+_vm._s(_vm.value)+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }